import { useStore } from 'effector-react'

import {
  $promoCodeUsageList,
  $totalCountOfPromoCodeUsageList,
  getPromoCodeUsageList,
  promoCodeUsageListMounted,
} from './model'
import { PromoCodeUsageRequest } from './types'

export const usePromoCodeUsageList = () => {
  const promoCodeUsageList = useStore($promoCodeUsageList)

  const loading = useStore(getPromoCodeUsageList.pending)

  const totalCountOfPromoCodeUsageList = useStore(
    $totalCountOfPromoCodeUsageList,
  )

  const onChangePromoCodeUsageList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
  }: PromoCodeUsageRequest) => {
    promoCodeUsageListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
    })
  }

  return {
    promoCodeUsageList,
    totalCountOfPromoCodeUsageList,
    loading,
    onChangePromoCodeUsageList,
  }
}
